import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    error: {
      color: red.A400,
    },
    root: {
      padding: theme.spacing(2),
    },
    metadata: {
      width: '50%',
      marginTop: theme.spacing(3),
    },
    addNote: {
      float: 'right'
    },
    list: {
      width: '80%',
    }
  }),
);

export default useStyles;